// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21buF","content":"styles_content__1OwgE","row":"styles_row__2368i","footer":"styles_footer__2Ca2S","phraseLength":"styles_phraseLength__10iB6"};